import Skeleton from '@mui/material/Skeleton';

const CommentSkeleton = () => {
  return (
    <div className='flex flex-col gap-2'>
      <Skeleton variant="circular" width={40} height={40} />
      <Skeleton variant="rounded" width={'100%'} height={60} />
    </div>
  );
};

export default CommentSkeleton;
